import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Ladybug } from "@/components/site/Ladybug";

const LINKS = [
  ["/", "Home"],
  ["/clinic", "Clinic & Healing Womb"],
  ["/university", "University"],
  ["/blog", "Blog"],
  ["/ambassadors", "Healing Ambassadors"],
  ["/apply", "Apply"],
];

const NavItems = ({ onClick }) =>
  LINKS.map(([to, label]) => (
    <NavLink
      key={to}
      to={to}
      end={to === "/"}
      onClick={onClick}
      data-testid={`nav-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
      className={({ isActive }) =>
        `text-sm tracking-wide transition-colors duration-300 hover:text-[#b6689a] ${isActive ? "text-[#b6689a]" : "text-[#232b1b]/80"}`
      }
    >
      {label}
    </NavLink>
  ));

export const Header = () => {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const cta = user ? (
    <Link to={user.role === "admin" ? "/admin" : "/members"} data-testid="header-members-btn" className="btn btn-olive !py-2.5 !px-5">
      {user.role === "admin" ? "Admin" : "Members Area"}
    </Link>
  ) : (
    <Link to="/ambassadors?mode=login#join" data-testid="header-login-btn" className="btn btn-ghost !py-2.5 !px-5">
      Ambassador Login <Ladybug size={14} rotate={15} />
    </Link>
  );
  return (
    <header className="sticky top-0 z-50 bg-[#faf7f2] border-b border-[#dacac1]/60">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-28 flex items-center justify-between gap-6">
        <Link to="/" data-testid="header-logo" className="flex items-center gap-3 shrink-0">
          <img src="/img/logo.jpg" alt="The Healers University" data-testid="header-logo-img" className="h-[92px] w-auto mix-blend-multiply" />
        </Link>
        <nav className="hidden lg:flex items-center gap-7"><NavItems /></nav>
        <div className="hidden lg:block">{cta}</div>
        <button className="lg:hidden text-[#577731]" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle" aria-label="Menu">
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden flex flex-col gap-5 px-6 pb-8 pt-2 bg-[#faf7f2]" data-testid="mobile-menu">
          <NavItems onClick={() => setOpen(false)} />
          <div onClick={() => setOpen(false)}>{cta}</div>
        </div>
      )}
    </header>
  );
};
